import { StatusEnum, ChatType as ChatTypeEnum } from "./graphql";

export type TestParticipationStatus = `${StatusEnum}` | "";
export type ChatType = `${ChatTypeEnum}`;
export enum Activity {
  Exploratory = "exploratory",
  Localization = "localization",
  TestCaseRun = "test_case_run",
  Translation = "translation",
}
